module.exports = __webpack_public_path__ + "img/neoco-book-cover.f7f7c871.png";